module.exports = __webpack_public_path__ + "img/portfolio_color.22242424.webp";